<template>
	<Icon>
		<template #component>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
				<path fill="currentColor" d="M4 9q-.425 0-.712-.288T3 8t.288-.712T4 7h3q.825 0 1.413.588T9 9zm2 9q1.25 0 2.125-.875T9 15t-.875-2.125T6 12t-2.125.875T3 15t.875 2.125T6 18m13.5 0q.625 0 1.063-.437T21 16.5t-.437-1.062T19.5 15t-1.062.438T18 16.5t.438 1.063T19.5 18M6 16.5q-.625 0-1.062-.437T4.5 15t.438-1.062T6 13.5t1.063.438T7.5 15t-.437 1.063T6 16.5m14-3.475q.65.125 1.075.338t.925.687V8q0-.825-.587-1.412T20 6h-6.3l-1.05-1.1l1.4-1.4l-.7-.7L9.8 6.35l.75.7l1.4-1.4L13 6.7V9q0 .825-.587 1.413T11 11H8.975q.575.425.925.875T10.6 13h.4q1.65 0 2.825-1.175T15 9V8h5zM16.025 16q.15-.675.363-1.088T17.05 14H10.9q.1.575.1 1t-.1 1zm3.475 4q-1.45 0-2.475-1.025T16 16.5t1.025-2.475T19.5 13t2.475 1.025T23 16.5t-1.025 2.475T19.5 20M6 20q-2.075 0-3.537-1.463T1 15t1.463-3.537T6 10t3.538 1.463T11 15t-1.463 3.538T6 20m9.825-9"/>
			</svg>
		</template>
	</Icon>
</template>

<script>
import Icon from '@ant-design/icons-vue';

// https://icones.js.org/collection/material-symbols?category=Transit&icon=material-symbols:agriculture-outline
export default {
	components: { Icon },
};
</script>
